import { OptionFilter } from '../lookup/ResolutionSchema.js';
import { PModel, PropertyPath } from '../engine.js';
import { Option } from '../option.js';
import { Schema } from '../schema.js';


export class CSPUtils {
  static applyFiltersTo(schema: Schema, topFilters: OptionFilter[], optionsPotentialValues: Map<PropertyPath, Option[]>, model: PModel) {
    for (const filter of topFilters) {
      const options = optionsPotentialValues.get(filter.optionPropertyPath);
      if (!options) {
        continue;
      }
      if (!options.length) {
        throw new Error(`No available values for ${filter.optionPropertyPath}`)
      }
      const resolutionSchemaCompatibleOptions = options.filter(option => filter.match(schema, model, option));
      optionsPotentialValues.set(filter.optionPropertyPath, resolutionSchemaCompatibleOptions);
    }
  }
}
